import { render, staticRenderFns } from "./history2.vue?vue&type=template&id=22bbc1c4"
import script from "./history2.vue?vue&type=script&lang=js"
export * from "./history2.vue?vue&type=script&lang=js"
import style0 from "./history2.vue?vue&type=style&index=0&id=22bbc1c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
